/**
 * VUEshop
 * ============================================================================
 * * 版权所有 2015-2027 深圳搜豹网络科技有限公司，并保留所有权利。
 * 网站地址: http://www.vueshop.com.cn
 * ----------------------------------------------------------------------------
 * 这不是一个自由软件！您只能在不用于商业目的的前提下对程序代码进行修改和使用 .
 * 不允许对程序代码以任何形式任何目的的再发布。
 * ============================================================================
 * $Author: soubao-java 2020-07-22 $
 */
import Vue from 'vue'
import Router from 'vue-router';
import store from '@/store/store.js';
import { getToken } from "@/utils/auth.js";
Vue.use(Router)
const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}
const routerConfig = [
	{
		path: "/",
		redirect: '/login',
	},
	{
		path: "/404",
		name: "404",
		meta: {
			title: '404'
		},
		component: () => import("@/view/404/index.vue")
	},
	{
		path: "/jurisdiction",
		name: "jurisdiction",
		meta: {
			title: '权限'
		},
		redirect: {
			path: '/jurisdiction/menus'
		},
		component: () => import("@/view/jurisdiction/index.vue"),
		children: [
			{
				path: "/jurisdiction/menus",
				name: "jurisdiction",
				meta: {
					title: '菜单'
				},
				component: () => import("@/view/jurisdiction/menus.vue")
			},
			{
				path: "/jurisdiction/roles",
				name: "jurisdiction",
				meta: {
					title: '角色'
				},
				component: () => import("@/view/jurisdiction/roles.vue")
			},
			{
				path: "/jurisdiction/admin_list",
				name: "jurisdiction",
				meta: {
					title: '角色'
				},
				component: () => import("@/view/jurisdiction/admin_list.vue")
			},
		]
	},
	{
		path: "/login",
		name: "login",
		component: () => import('@/view/choice/index.vue'),
		// children: MainArr //顶部第一级路由
	},
	{
		path: "/choice",
		name: "choice",
		component: () => import('@/view/index/login.vue'),
		// children: MainArr //顶部第一级路由
	},
	{
		path: "/supindex",
		name: "supindex",
		component: () => import('@/view/index/suplogin.vue'),
		// children: MainArr //顶部第一级路由
	},
	{
		path: '/deploy_pages',
		name: 'deploy_pages',
		component: () => import('@/view/page/mobile_list/deploy_pages.vue'),
	},
]


const router = new Router({
	mode: process.env.VUE_APP_MODE,
	routes: routerConfig,
	base: '/' + process.env.VUE_APP_NAME, // nginx location路径， 也就是请求路径
});

const whiteList = ['/login', '/deploy_pages', '/choice', '/supindex']
router.beforeEach((to, from, next) => {
	let path = to.path;
	let menuList = store.state.menuList || [];
	let data = readNodes(menuList)
	/*先判断是否是白名单*/
	if (whiteList.indexOf(to.path) !== -1) {
		next()
		return;
	}
	/*通过是否有token */
	if (getToken()) {
		if (menuList.length == 0) {
			next()
			return false
		}
		next()
	} else {
		next('/login')
		return
	}
	if (to.meta.title) {
		document.title = to.meta.title;
	}

})

function readNodes(nodes = [], arr = []) {
	for (let item of nodes) {
		arr.push(item)
		if (item.children && item.children.length) readNodes(item.children, arr)
	}
	return arr
}

export default router;

